import { useState } from 'react';
import Button from '../../components/Button';
import * as PromoBox from '../../components/PromoBox';
import ChatPromotionModal from './Modal';
import styles from './style.m.less';

export default function ChatPromotion({ onDismiss }) {
    const [showModal, setShowModal] = useState(false);
    return (
        <PromoBox.Container>
            <PromoBox.Header>
                <PromoBox.Heading>
                    Using <img className={styles.icon} src={require('./slack-white.svg')} alt="" />
                    Slack?
                </PromoBox.Heading>
                <PromoBox.CloseButton onClick={onDismiss} />
            </PromoBox.Header>
            <img className={styles.illustration} src={require('./illustration.svg')} alt="" />
            <PromoBox.Paragraph>
                Bring employee recognition and objectives to your company's favorite messaging tool - right where the
                conversation is already happening.
            </PromoBox.Paragraph>
            <PromoBox.CtaContainer>
                <Button className="small outline" onClick={() => setShowModal(true)}>
                    Learn more
                </Button>
            </PromoBox.CtaContainer>
            <ChatPromotionModal isOpen={showModal} onClose={() => setShowModal(false)} />
        </PromoBox.Container>
    );
}
